import { type Components, type Theme } from "@mui/material/styles";

export const tablePagination: Components<Theme>["MuiTablePagination"] = {
  styleOverrides: {
    select: {
      padding: 0,
    },
  },
};
